import { useContext } from 'react';
import { ChatbotContext } from '../contexts/chatbot-context';
import viewStates from '../helpers/viewStates';

const useNavigation = () => {
  const [state, setState] = useContext(ChatbotContext);

  const setChatView = () => {
    setState((currentState) => ({
      ...currentState,
      view: viewStates.CHAT,
      initialMessage: {
        id: -1
      }
    }));
  };

  const setInitialMessage = (initialMessage) => {
    setState((currentState) => ({
      ...currentState,
      view: viewStates.CHAT,
      backActive: false,
      initialMessage
    }));
  };

  const reset = () => {
    setState((currentState) => ({
      ...currentState,
      view: viewStates.START,
      question: false,
      messages: [],
      canInteract: false,
      backActive: true,
      initialMessage: null
    }));
  };

  return {
    view: state.view,
    initialMessage: state.initialMessage,
    backActive: state.backActive,
    reset,
    setInitialMessage,
    setChatView
  };
};

export default useNavigation;
